import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const categoryList = createAsyncThunk('category/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `category`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const categoryDetails = createAsyncThunk('category/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `category/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addCategory = createAsyncThunk('category/add', async (data) => {

    const bodyFormData = new FormData()
    bodyFormData.append('category_name', data?.values?.name)
    bodyFormData.append('category_description', data?.values?.description)
    bodyFormData.append('status', data?.values?.status)
    {
        data?.values?.image &&
            bodyFormData.append('category_image', data.values.image)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'category',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "category_image", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateCategory = createAsyncThunk('category/update', async (data) => {

    const bodyFormData = new FormData()
    bodyFormData.append('category_id', data?.values?.id)
    bodyFormData.append('category_name', data?.values?.name)
    bodyFormData.append('category_description', data?.values?.description)
    bodyFormData.append('status', data?.values?.status)
    {
        data?.values?.image &&
            bodyFormData.append('category_image', data.values.image)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_category',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "category_image", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delCategory = createAsyncThunk('category/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `category/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const category = createSlice({
    name: 'category',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(categoryList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(categoryDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default category.reducer;